import {
  createChannel as requestCreateChannel,
  createPipe as requestCreatePipe,
  deleteChannel as requestDeleteChannel,
  deletePipe as requestDeletePipe,
  getChannels,
  updateChannel as requestUpdateChannel,
  updatePipe as requestUpdatePipe
} from "@utils/aegean_api_handler";

export const GET_CHANNELS_REQUEST = "GET_CHANNELS_REQUEST";
export const GET_CHANNELS_SUCCESS = "GET_CHANNELS_SUCCESS";
export const GET_CHANNELS_ERROR = "GET_CHANNELS_ERROR";
export const CREATE_CHANNEL_REQUEST = "CREATE_CHANNEL_REQUEST";
export const CREATE_CHANNEL_SUCCESS = "CREATE_CHANNEL_SUCCESS";
export const CREATE_CHANNEL_ERROR = "CREATE_CHANNEL_ERROR";
export const DELETE_CHANNEL_REQUEST = "DELETE_CHANNEL_REQUEST";
export const DELETE_CHANNEL_SUCCESS = "DELETE_CHANNEL_SUCCESS";
export const DELETE_CHANNEL_ERROR = "DELETE_CHANNEL_ERROR";
export const UPDATE_CHANNEL_REQUEST = "UPDATE_CHANNEL_REQUEST";
export const UPDATE_CHANNEL_SUCCESS = "UPDATE_CHANNEL_SUCCESS";
export const UPDATE_CHANNEL_ERROR = "UPDATE_CHANNEL_ERROR";
export const CREATE_PIPE_REQUEST = "CREATE_PIPE_REQUEST";
export const CREATE_PIPE_SUCCESS = "CREATE_PIPE_SUCCESS";
export const CREATE_PIPE_ERROR = "CREATE_PIPE_ERROR";
export const DELETE_PIPE_REQUEST = "DELETE_PIPE_REQUEST";
export const DELETE_PIPE_SUCCESS = "DELETE_PIPE_SUCCESS";
export const DELETE_PIPE_ERROR = "DELETE_PIPE_ERROR";
export const UPDATE_PIPE_REQUEST = "UPDATE_PIPE_REQUEST";
export const UPDATE_PIPE_SUCCESS = "UPDATE_PIPE_SUCCESS";
export const UPDATE_PIPE_ERROR = "UPDATE_PIPE_ERROR";

export const fetchChannels = () => (dispatch, getState) => {
  const store = getState();

  if (store.channels.isFetching || store.channels.data) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({ type: GET_CHANNELS_REQUEST });

  return getChannels()
    .then((result) => {
      dispatch({
        type: GET_CHANNELS_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_CHANNELS_ERROR,
        error
      });
    });
};

export const createChannel = channel => (dispatch) => {
  dispatch({ type: CREATE_CHANNEL_REQUEST });

  return requestCreateChannel(channel)
    .then((channels) => {
      dispatch({
        type: CREATE_CHANNEL_SUCCESS,
        data: channels
      });
    })
    .catch((error) => {
      dispatch({
        type: CREATE_CHANNEL_ERROR,
        error
      });
    });
};

export const deleteChannel = channel_id => (dispatch) => {
  dispatch({ type: DELETE_CHANNEL_REQUEST });

  return requestDeleteChannel(channel_id)
    .then((channels) => {
      dispatch({
        type: DELETE_CHANNEL_SUCCESS,
        data: channels
      });
    })
    .catch((error) => {
      dispatch({
        type: DELETE_CHANNEL_ERROR,
        error
      });
    });
};

export const updateChannel = (channel_id, channel) => (dispatch) => {
  dispatch({ type: UPDATE_CHANNEL_REQUEST });

  return requestUpdateChannel(channel_id, channel)
    .then((channels) => {
      dispatch({
        type: UPDATE_CHANNEL_SUCCESS,
        data: channels
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_CHANNEL_ERROR,
        error
      });
    });
};

export const createPipe = pipe => (dispatch) => {
  dispatch({ type: CREATE_PIPE_REQUEST });

  return requestCreatePipe(pipe)
    .then(({ channels, pipe }) => {
      dispatch({
        type: CREATE_PIPE_SUCCESS,
        data: channels
      });
      return pipe;
    })
    .catch((error) => {
      dispatch({
        type: CREATE_PIPE_ERROR,
        error
      });
    });
};

export const deletePipe = pipe_id => (dispatch) => {
  dispatch({ type: DELETE_PIPE_REQUEST });

  return requestDeletePipe(pipe_id)
    .then(({ channels, pipe }) => {
      dispatch({
        type: DELETE_PIPE_SUCCESS,
        data: channels
      });
      return pipe;
    })
    .catch((error) => {
      dispatch({
        type: DELETE_PIPE_ERROR,
        error
      });
    });
};

export const updatePipe = (pipe_id, pipe) => (dispatch) => {
  dispatch({ type: UPDATE_PIPE_REQUEST });

  return requestUpdatePipe(pipe_id, pipe)
    .then(({ channels, pipe }) => {
      dispatch({
        type: UPDATE_PIPE_SUCCESS,
        data: channels
      });
      return pipe;
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_PIPE_ERROR,
        error
      });
    });
};
